import { Box } from 'grommet';
import FileActionEditor from 'modules/admin/components/FileActionEditor';
import MarkdownActionEditor from 'modules/admin/components/MarkdownActionEditor';
import React, { ReactNode } from 'react';
import { Asset } from 'types';
import Image from './common/Image';

interface SimpleMarkdownProps {
  asset: Asset;
  children?: ReactNode;
}

const SimpleMarkdown = ({ asset, children }: SimpleMarkdownProps) => (
  <Box align="center" justify="center">
    <Box
      align="center"
      justify="center"
      height={{ min: 'medium' }}
      pad="large"
      width={{ max: 'large' }}
    >
      <Box>
        {asset?.image && (
          <Image
            alt={asset.label}
            src={asset.image}
            style={{ maxHeight: '200px', width: '100%' }}
          />
        )}
        {asset && <MarkdownActionEditor id={asset.id} />}
        {children && children}
        {asset && <FileActionEditor id={asset.id} />}
      </Box>
    </Box>
  </Box>
);

export default SimpleMarkdown;
